import React, { useCallback, useContext } from "react";
import { withRouter, Redirect } from "react-router";
import {app} from "./base.js";
import { AuthContext } from "./Auth.js";

const Login = ({ history }) => {
  const handleLogin = useCallback(
    async event => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);
        history.push("/");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  const { currentUser } = useContext(AuthContext);

  if (currentUser) {
    return <Redirect to="/" />;
  }

  return (
      <div className='fullContainer'>

        <div className='pageContainer'>
            <div className='loginContainer container'>
                <h1>LOGIN</h1>
                <div className='container'>
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input type="email" className="form-control" name="email" aria-describedby="emailHelp"/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input name="password" type="password" className="form-control"/>
                    </div>
                    <button type="submit" className="btn btn-primary submitButton">Submit</button>
                </form>
                </div>
            </div>
        </div>
      </div>
  );
};

export default withRouter(Login);